/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SharedHeadTitleTag_metadata$ref: FragmentReference;
export type SharedHeadTitleTag_metadata = {|
  +title: ?string,
  +$refType: SharedHeadTitleTag_metadata$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SharedHeadTitleTag_metadata",
  "type": "MetaData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ecdf49ebde8460cdcb8f117d80dc9a0e';
module.exports = node;
